import React from 'react';
import { motion } from 'framer-motion';
import './Overlays.css'

export default function RoyalPairOverlay({ gs, active }) {
  if (!active || gs.royal_pair_team === -1) return null;

  const teamName = gs.royal_pair_team === 0 ? "Team ♦" : "Team ♠";
  const isBidderTeam = gs.royal_pair_team === (gs.bid_winner % 2);

  return (
    <div className="royal-pair-overlay-container">
      <motion.div 
        initial={{ scale: 0.5, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 1.5, opacity: 0 }}
        className="royal-pair-card"
      >
        <div className="crown-icon">👑</div>
        <h2>ROYAL PAIR!</h2>
        <p><strong>{teamName}</strong> holds the King & Queen of Trump.</p>
        <div className="target-adjustment">
          Target adjusted to <span className="new-bid">{gs.current_bid}</span>
          <div className="adjustment-detail">
            ({isBidderTeam ? "-4 bonus" : "+4 penalty"})
          </div>
        </div>
      </motion.div>
    </div>
  );
}
